import { Navigate, useLocation, useOutlet } from "react-router-dom";
import { useContextUsuario } from "../contexto/usuario/UsuarioContext";
import { mostraAlertaError } from "../componentes/alerts/sweetAlert";
import { EmpleadoState } from "../contexto/empleado/EmpleadoState";

const normalizePath = (path) => (path.endsWith("/") ? path : path + "/");

const obtenerSubRuta = (rutaActual, rutaBase) =>
  rutaActual.replace(normalizePath(rutaBase), "").split("/")[0] || "";

const tienePermisoRuta = (subRuta, permisos, rutaBase = "") => {
  const ruta = subRuta.replace(/-/g, " ").trim().toLowerCase();
  const permsLower = permisos.map(p => p.trim().toLowerCase());
  if (rutaBase.includes("planillas")) {
    const tieneGestion = permsLower.some(p => ["gestion", "gestionar", "ver"].includes(p));
    const tieneGenerar = permsLower.includes("generar");
    if (ruta === "" || ruta === "detalle") {
      return tieneGestion || tieneGenerar;
    }
    if (ruta === "generar") {
      return tieneGenerar;
    }
    if (ruta === "configuracion" || ruta === "prestamos") {
      return tieneGestion;
    }
  }
  return ruta === "" || permsLower.includes(ruta);
};

export const AdminLayout = () => {
  const outlet = useOutlet();
  const location = useLocation();
  const { usuario } = useContextUsuario();

  if (!usuario || usuario.tipo !== "Empleado") {
    mostraAlertaError("No tienes permitido acceder a este sitio");
    return <Navigate to="/login" />;
  }

  const rutaActual = normalizePath(location.pathname);
  const esRutaLibre = rutaActual.includes("/app/admin/perfil");
  const accesos = (usuario.accesos || []).filter(a => a.estado === "Activo");

  let acceso = accesos.find(({ ruta }) =>
    rutaActual.startsWith(normalizePath(ruta))
  );

  // Soporte Frontend para Planillas mientras el backend implementa el permiso en BD:
  // Si no está registrado en BD aún, solo administradores/gerentes (con permiso en Empleados) pueden acceder.
  const esRutaPlanillas = rutaActual.startsWith("/app/admin/planillas");
  const esAdminOGerente = accesos.some(a =>
    normalizePath(a.ruta).includes("/app/admin/empleados") &&
    (a.permisos || "").split(",").some(p => ["Accesos", "Gestionar"].includes(p.trim()))
  );

  if (esRutaPlanillas && !acceso && esAdminOGerente) {
    acceso = {
      ruta: "/app/admin/planillas/",
      permisos: "Gestion, Generar",
      estado: "Activo"
    };
  }

  const primerAcceso = accesos[0];
  const rutaInicio = primerAcceso ? normalizePath(primerAcceso.ruta) : "/app/admin/";

  if (!acceso && !esRutaLibre) {
    mostraAlertaError("No tienes acceso a esta ruta");
    return <Navigate to={rutaInicio} />;
  }

  const subRuta = acceso ? obtenerSubRuta(rutaActual, acceso.ruta) : "";
  const permisos = acceso && acceso.permisos ? acceso.permisos.split(",") : [];

  if (!esRutaLibre && !tienePermisoRuta(subRuta, permisos, acceso?.ruta || "")) {
    mostraAlertaError("No tienes permiso para acceder a esta sección");
    return <Navigate to={rutaInicio} />;
  }

  return <EmpleadoState>{outlet}</EmpleadoState>;
};
